
import fb from '../firebase'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import DataHelpers from '../helpers/DataHelpers'

var db = fb.database()

const state = {
    templates: []
}

// getters
const getters = {
    //checkoutStatus: state => state.checkoutStatus

    templates: state => {
        return state.templates
    },
    loadedTemplates: state => {
        return state.loadedTemplates
    }

}

// actions
const actions = {

    loadTemplates(context) {
        return new Promise(function(resolve, reject) {
            if(context.getters.loadedTemplates)
                resolve(context.getters.templates)

            let ref = db.ref(`tenants/${context.getters.tenantKey}/templates`)
            ref.on('value', function(snap) {
                console.log('store > loadedTemplates')
                let templates = FirebaseHelpers.snapshotToArray(snap).sort((a, b) => {
                    if(a.group < b.group) return -1
                    if(a.group > b.group) return 1
                    if(a.name < b.name) return -1
                    if(a.name > b.name) return 1
                    return 0
                })
                context.commit('templates', templates)
                context.commit('loadedTemplates', true)
                resolve(templates)
            })  
        })
    },

    saveTemplate(context, payload) {
        const key = payload.key || payload['.key'] || DataHelpers.getKey()
        let ref = db.ref(`tenants/${context.getters.tenantKey}/templates/${key}`)
        ref.update(FirebaseHelpers.cloneWithoutKey(payload))
    },

    deleteTemplate(context, payload) {
        const key = payload.key || payload['.key']
        let ref = db.ref(`tenants/${context.getters.tenantKey}/templates/${key}`)
        ref.remove()
    }
}

// mutations
const mutations = {

    templates (state, templates) {
        state.templates = templates           
    },              
    loadedTemplates (state, val) {
        state.loadedTemplates = val           
    }, 
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/TemplatesStore.js